import { Box, Typography } from '@mui/material'
import React from 'react'

import { renderFilter } from './filters/renderFilter'
import type { GridAdditionalFilter, GridAdditionalFilterValue } from './types'

type Props = {
	filters: GridAdditionalFilter[]
	values: GridAdditionalFilterValue[]
	onChange: (values: GridAdditionalFilterValue[]) => void
}

export const AdditionalFiltersToolbar: React.FC<Props> = ({ filters, values, onChange }) => {
	if (filters.length === 0) {
		return null
	}
	const valueFor = (key: string): unknown => values.find((v) => v.key === key)?.value
	const update = (filter: GridAdditionalFilter, value: unknown): void => {
		const without = values.filter((v) => v.key !== filter.key)
		if (value === '' || value === null || (Array.isArray(value) && value.length === 0)) {
			onChange(without)
			return
		}
		onChange([...without, { key: filter.key, kind: filter.filter.kind, value }])
	}
	return (
		<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, p: 1, alignItems: 'center' }}>
			{filters.map((f) => (
				<Box key={f.key} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<Typography variant="body2">{f.label}</Typography>
					{renderFilter({
						definition: f.filter,
						value: valueFor(f.key),
						onChange: (value) => update(f, value),
					})}
				</Box>
			))}
		</Box>
	)
}
